import React from 'react';
import { Outlet } from 'react-router-dom';
import BreadCrumb from '../BreadCrumb/BreadCrumb';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Sidebar from '../Sidebar/Sidebar';
import { StateProps } from '../../redux/reducer';
import { useDispatch, useSelector } from 'react-redux';
import ActivityIndicator from '../ActivityIndicator/ActivityIndicator';
import Download from '../Download/Download';
import FlashBar from '../FlashBar/FlashBar';
import { updateFlashBar } from '../../redux/action';

const Layout = () => {
  const dispatch = useDispatch();
  const sidebarLayout = useSelector((state: StateProps) => state.sidebarLayout);
  const isLoading = useSelector((state: StateProps) => state.isLoading);
  const flashBar = useSelector((state: StateProps) => state.flashbar);

  const flashBarClose = () => {
    const obj = {
      isOpen: false,
      message: '',
      type: '',
    };
    dispatch(updateFlashBar(obj));
  };

  return (
    <div>
      {isLoading ? <ActivityIndicator /> : null}
      <div className="w-full min-h-screen h-full bghandler">
        <div className="sticky top-0 z-50">
          <Header />
        </div>
        <div className="fixed z-10">
          <Sidebar />
        </div>
        <div className={`${sidebarLayout ? 'sm:ml-48' : 'sm:ml-[60px]'} p-2`}>
          <BreadCrumb />
          <div className="py-2">
            <Outlet />
            <Footer />
          </div>
        </div>
      </div>
      <div>
        <Download />
      </div>
      <FlashBar
        message={flashBar.message}
        isOpen={flashBar.isOpen}
        type={flashBar.type}
        handleClose={() => flashBarClose()}
      />
    </div>
  );
};

export default Layout;
